<template>
  <figure class="page-image" :class="{'is-sticky': sticky}" v-if="src.length">
    <img :src="src" :alt="alt" />
  </figure>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    sticky: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>
